// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/utils/ContentTravelHandlers.js
import { API_ENDPOINTS, API_URLS } from '../api/api';

const commonHeaders = {
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
};

export const fetchTravelData = async (setTravelData, setTotalCount, setIsLoading, currentPage, pageLength) => {
  setIsLoading(true);
  const offset = (currentPage - 1) * pageLength;
  try {
    const response = await fetch(`${API_ENDPOINTS.TRAVEL_VIEW}&offset=${offset}&limit=${pageLength}`, {
      method: 'GET',
      headers: commonHeaders,
    });
    if (!response.ok) throw new Error('Failed to fetch travel data');
    const data = await response.json();
    setTravelData(data.jobs.map(item => ({ ...item, key: item.Job_ID })));
    setTotalCount(data.total_count || 0);
  } catch (error) {
    console.error('Fetch travel error:', error);
  } finally {
    setIsLoading(false);
  }
};

export const handleAddTravel = (setCurrentTravel, setFormMode, setIsFormVisible) => {
  setCurrentTravel(null);
  setFormMode('add');
  setIsFormVisible(true);
};

export const handleEditTravel = (travelId, travelData, setCurrentTravel, setFormMode, setIsFormVisible) => {
  const travelToEdit = travelData.find((travel) => travel.Job_ID === travelId);
  setCurrentTravel(travelToEdit);
  setFormMode('edit');
  setIsFormVisible(true);
};

export const handleCancelEdit = (setIsFormVisible) => {
  setIsFormVisible(false);
};

const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await fetch(API_URLS.IMAGE_UPLOAD, {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to upload image: ${response.status} ${response.statusText} - ${errorText}`);
    }
    const result = await response.json();
    if (!result.resizedFileURLs || !result.originalFileURLs) {
      throw new Error('Invalid response format: missing resizedFileURLs or originalFileURLs');
    }
    return { resizedUrl: result.resizedFileURLs[0], originalUrl: result.originalFileURLs[0] };
  } catch (error) {
    console.error('Image upload error:', error);
    throw error;
  }
};

export const handleSaveTravel = async (data, setIsFormVisible, setIsLoading, fetchTravelDataCallback, travelData) => {
  setIsLoading(true);
  let errorMessage = '';
  try {
    const travelPayload = {
      Job_ID: data.Job_ID || null,
      Member_ID: 1,
      Job_Code: data.Job_ID ? data.Job_Code : `TRV${Date.now()}`,
      Job_Name: data.Job_Name,
      Job_Details: data.Job_Details,
      Job_Detail2: data.Job_Detail2,
      Job_Detail3: data.Job_Detail3,
      PROVINCE_ID: 1,
      ProductCategoryID: 4,
      ProductCategoryID2: 83,
      Job_Addr: "Unknown",
      Job_Maps: data.Job_Maps,
      Job_Date: data.Job_Date,
      Job_Time: "08:00:00",
      Job_visitors: 50,
      StatusJob_ID: 1,
    };

    const apiEndpoint = data.Job_ID ? API_ENDPOINTS.TRAVEL_UPDATE : API_ENDPOINTS.TRAVEL_INSERT;
    const method = data.Job_ID ? 'PUT' : 'POST';
    const travelResponse = await fetch(apiEndpoint, {
      method: method,
      headers: commonHeaders,
      body: JSON.stringify(travelPayload),
    });
    if (!travelResponse.ok) throw new Error(`Failed to ${data.Job_ID ? 'update' : 'insert'} travel data`);
    const travelResult = await travelResponse.json();
    const jobId = travelResult.Job_ID;

    // Handle image only in add mode
    let imageUrl = data.JobImg_img;
    let imageUrlOriginal = data.JobImg_img_original;
    if (!data.Job_ID && data.JobImg_file && data.JobImg_file instanceof File) { // Only in add mode
      try {
        const uploadResult = await uploadImage(data.JobImg_file);
        imageUrl = uploadResult.resizedUrl;
        imageUrlOriginal = uploadResult.originalUrl;

        if (imageUrl && imageUrlOriginal && jobId) {
          const imagePayload = {
            JobImg_img: imageUrl,
            JobImg_img_original: imageUrlOriginal,
            Job_ID: jobId,
            StatusJobImg_ID: 1,
            JobImg_sort: 0,
          };
          const imageResponse = await fetch(API_ENDPOINTS.TRAVEL_INSERT_IMAGE, {
            method: 'POST',
            headers: commonHeaders,
            body: JSON.stringify(imagePayload),
          });
          if (!imageResponse.ok) {
            console.warn('Failed to insert travel image, but travel data saved:', imageResponse.statusText);
            errorMessage += 'Image insertion failed, but travel data saved. ';
          } else {
            console.log('Image inserted successfully');
          }
        }
      } catch (uploadError) {
        console.warn('Image upload failed, proceeding without image:', uploadError);
        errorMessage += 'Travel data saved, but image upload failed due to CORS or server issue. ';
        imageUrl = null;
        imageUrlOriginal = null;
      }
    }
    // In update mode (data.Job_ID exists), no image API calls are made

    setIsFormVisible(false);
    fetchTravelDataCallback();
  } catch (error) {
    console.error('Save travel error:', error);
    errorMessage = errorMessage || `Failed to save travel data: ${error.message}`;
    alert(errorMessage);
  } finally {
    setIsLoading(false);
  }
};

export const handleDelete = async (selectedTravelIds, setIsLoading, fetchTravelDataCallback) => {
  setIsLoading(true);
  try {
    console.log('Delete travel IDs:', selectedTravelIds);
    fetchTravelDataCallback();
  } catch (error) {
    console.error('Delete travel error:', error);
  } finally {
    setIsLoading(false);
  }
};